module.exports = __webpack_public_path__ + "static/media/truck-icon-idle.e685b5de.svg";